import _regenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import { abandonAPI, addIntentions } from '@/api/admissionCounseling/myCustomers';
import { getMyCollected, editStars } from '@/api/admissionCounseling/intentionCustomer';
import moment from 'moment';
import { validateMoney } from '@/utils/validate';
import { getToken } from '@/utils/auth';
export default {
  name: 'BtnsCom',
  props: {
    cId: {
      type: Number,
      required: true
    },
    drawerForm: {
      type: Object,
      required: true
    },
    rightComData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      abandon: {
        isExist: false,
        visible: false,
        remark: '',
        loading: false
      },
      collect: {
        limit: 0,
        total: 0,
        // 已经收藏了多少
        isStar: false
      },
      intentionForm: {
        intentionAmount: '',
        intentionTime: ''
      },
      addIntentionFormRules: {
        intentionAmount: [{
          required: true,
          trigger: 'blur',
          message: '请填写意向金额'
        }],
        intentionTime: [{
          required: true,
          trigger: 'blur',
          message: '请选择意向报名时间'
        }]
      },
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          return moment(date).isBefore(moment());
        }
      },
      intention: {
        isExist: false,
        visible: false,
        loading: false
      },
      validateMoney: validateMoney
    };
  },
  watch: {
    cId: function cId(newVal) {
      var getMyCollect = this.getMyCollect,
        collect = this.collect,
        drawerForm = this.drawerForm;
      if (newVal) {
        collect.isStar = drawerForm.stared;
        getMyCollect();
      }
    }
  },
  created: function created() {
    this.getMyCollect();
  },
  methods: {
    handleAbandon: function handleAbandon() {
      var abandon = this.abandon;
      !abandon.isExist && (abandon.isExist = true);
      abandon.visible = !abandon.visible;
      abandon.remark && (abandon.remark = '');
    },
    // 放弃
    submitAbandon: function submitAbandon() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var cId, abandon, handleAbandonLoading, $message, handleAbandon, remark, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              cId = _this.cId, abandon = _this.abandon, handleAbandonLoading = _this.handleAbandonLoading, $message = _this.$message, handleAbandon = _this.handleAbandon;
              remark = abandon.remark;
              handleAbandonLoading();
              _context.n = 1;
              return abandonAPI({
                id: cId,
                remark: remark
              });
            case 1:
              res = _context.v;
              if (typeof res === 'string') {
                $message({
                  type: 'success',
                  message: '放弃客户成功！'
                });
                handleAbandonLoading();
                handleAbandon();
                _this.$emit('submitSuccessed');
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    handleAbandonLoading: function handleAbandonLoading() {
      var abandon = this.abandon;
      abandon.loading = !abandon.loading;
    },
    getMyCollect: function getMyCollect() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, limit, totalElements, collect;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return getMyCollected();
            case 1:
              res = _context2.v;
              limit = res.limit, totalElements = res.totalElements;
              collect = _this2.collect;
              collect.limit = limit;
              collect.total = totalElements;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    handleCollect: function handleCollect() {
      var collect = this.collect;
      collect.isStar = !collect.isStar;
    },
    submitCollected: function submitCollected() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var collect, cId, $message, getMyCollect, isStar, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              collect = _this3.collect, cId = _this3.cId, $message = _this3.$message, getMyCollect = _this3.getMyCollect;
              isStar = collect.isStar;
              _context3.n = 1;
              return editStars({
                id: cId,
                isStar: isStar
              });
            case 1:
              res = _context3.v;
              if (typeof res === 'string') {
                $message({
                  type: 'success',
                  message: isStar ? '添加收藏成功！' : '取消收藏成功！'
                });
                // 为了更新drawerForm.stared
                _this3.$emit('refresh');
                getMyCollect();
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    // 打开添加意向对话框
    handleIntention: function handleIntention() {
      var rightComData = this.rightComData,
        handleIntentionVisible = this.handleIntentionVisible,
        $message = this.$message;
      if (rightComData.evaluation === 0) {
        handleIntentionVisible();
      } else {
        $message({
          type: 'error',
          message: "咨询评价选中为'有效'才可添加为意向客户！！！"
        });
      }
    },
    handleIntentionVisible: function handleIntentionVisible() {
      var intention = this.intention;
      !intention.isExist && (intention.isExist = true);
      intention.visible = !intention.visible;
    },
    submitIntention: function submitIntention() {
      var _this4 = this;
      var $refs = this.$refs,
        handleIntentionLoading = this.handleIntentionLoading,
        intentionForm = this.intentionForm,
        cId = this.cId,
        handleIntentionVisible = this.handleIntentionVisible;
      $refs['addIntentionForm'].validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(isPass) {
          var res;
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.n) {
              case 0:
                if (!isPass) {
                  _context4.n = 2;
                  break;
                }
                handleIntentionLoading();
                intentionForm.customerId = cId;
                _context4.n = 1;
                return addIntentions(intentionForm);
              case 1:
                res = _context4.v;
                if (res.id) {
                  handleIntentionLoading();
                  handleIntentionVisible();
                  $refs['addIntentionForm'].resetFields();
                  // 更新预约按钮
                  _this4.$emit('refresh');
                }
                _context4.n = 3;
                break;
              case 2:
                return _context4.a(2, false);
              case 3:
                return _context4.a(2);
            }
          }, _callee4);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    handleIntentionLoading: function handleIntentionLoading() {
      var intention = this.intention;
      intention.loading = !intention.loading;
    },
    // 报名
    handleSubmit: function handleSubmit() {
      var rightComData = this.rightComData,
        handleCreateOrder = this.handleCreateOrder,
        $message = this.$message;
      if (rightComData.evaluation === 0) {
        handleCreateOrder();
      } else {
        $message({
          type: 'error',
          message: '请选择咨询评价为“有效”后，方可报名！'
        }).showClose = true;
      }
    },
    handleCreateOrder: function handleCreateOrder() {
      var cId = this.cId,
        drawerForm = this.drawerForm;
      var orderUrl = process.env.VUE_APP_UOOC_ADMIN_URL;
      var name = drawerForm.name,
        contactPhone = drawerForm.contactPhone;
      var phone = contactPhone && contactPhone[0] || undefined;
      var pageUrl = encodeURIComponent("/studentCenter/studentMessage?type=add&id=".concat(cId, "&name=").concat(name, "&phone=").concat(phone, "&way=crm"));
      window.open("".concat(orderUrl, "?t=").concat(getToken(), "&p=").concat(pageUrl), '_blank');
    }
  }
};